import React, { lazy } from 'react'
import { Route, Switch } from 'react-router-dom'
import { FrontUrls } from 'Constants/FrontUrls'
import { SuspenseComponent } from 'Modules'

const RegistratorCabinetLogsLazy = lazy(
	() => import('Pages/registratorCabinet/logs/components/Logs')
)

export const RegistratorCabinetLogsRoutes = () => {
	return (
		<Switch>
			<Route
				path={FrontUrls.cabinet_redesign.logs}
				render={() => (
					<SuspenseComponent>
						<RegistratorCabinetLogsLazy />
					</SuspenseComponent>
				)}
				key={FrontUrls.cabinet_redesign.logs}
			/>
		</Switch>
	)
}
